package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ObjectiveReflectionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByObjective(objective_id: String, mapper: (
    id: String,
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByObjective(objective_id: String): Query<Objective_reflection> =
      selectByObjective(objective_id) { id, objective_id_, attempt, text, missed_deadline,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective_reflection(
      id,
      objective_id_,
      attempt,
      text,
      missed_deadline,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectAll(mapper: (
    id: String,
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_166_044_415, arrayOf("objective_reflection"), driver,
      "ObjectiveReflection.sq", "selectAll",
      "SELECT objective_reflection.id, objective_reflection.objective_id, objective_reflection.attempt, objective_reflection.text, objective_reflection.missed_deadline, objective_reflection.created_at, objective_reflection.updated_at, objective_reflection.is_deleted, objective_reflection.deleted_at, objective_reflection.synced_at FROM objective_reflection WHERE is_deleted = 0 ORDER BY attempt") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectAll(): Query<Objective_reflection> = selectAll { id, objective_id, attempt, text,
      missed_deadline, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective_reflection(
      id,
      objective_id,
      attempt,
      text,
      missed_deadline,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-415_090_768, arrayOf("objective_reflection"), driver,
      "ObjectiveReflection.sq", "selectDirty",
      "SELECT objective_reflection.id, objective_reflection.objective_id, objective_reflection.attempt, objective_reflection.text, objective_reflection.missed_deadline, objective_reflection.created_at, objective_reflection.updated_at, objective_reflection.is_deleted, objective_reflection.deleted_at, objective_reflection.synced_at FROM objective_reflection WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectDirty(): Query<Objective_reflection> = selectDirty { id, objective_id, attempt,
      text, missed_deadline, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Objective_reflection(
      id,
      objective_id,
      attempt,
      text,
      missed_deadline,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Objective_reflection> = selectByIdAnyState(id) {
      id_, objective_id, attempt, text, missed_deadline, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Objective_reflection(
      id_,
      objective_id,
      attempt,
      text,
      missed_deadline,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(478_151_423, """
        |INSERT INTO objective_reflection(id, objective_id, attempt, text, missed_deadline, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, objective_id)
          bindLong(2, attempt)
          bindString(3, text)
          bindString(4, missed_deadline)
          bindLong(5, created_at)
          bindLong(6, updated_at)
        }
    notifyQueries(478_151_423) { emit ->
      emit("objective_reflection")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_446_392_901,
        """UPDATE objective_reflection SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_446_392_901) { emit ->
      emit("objective_reflection")
    }
  }

  public fun update(
    objective_id: String,
    attempt: Long,
    text: String,
    missed_deadline: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(823_097_615,
        """UPDATE objective_reflection SET objective_id = ?, attempt = ?, text = ?, missed_deadline = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, objective_id)
          bindLong(1, attempt)
          bindString(2, text)
          bindString(3, missed_deadline)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(823_097_615) { emit ->
      emit("objective_reflection")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_078_172_424,
        """UPDATE objective_reflection SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_078_172_424) { emit ->
      emit("objective_reflection")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-243_499_283,
        """UPDATE objective_reflection SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-243_499_283) { emit ->
      emit("objective_reflection")
    }
  }

  private inner class SelectByObjectiveQuery<out T : Any>(
    public val objective_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective_reflection", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective_reflection", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-488_082_432,
        """SELECT objective_reflection.id, objective_reflection.objective_id, objective_reflection.attempt, objective_reflection.text, objective_reflection.missed_deadline, objective_reflection.created_at, objective_reflection.updated_at, objective_reflection.is_deleted, objective_reflection.deleted_at, objective_reflection.synced_at FROM objective_reflection WHERE objective_id = ? AND is_deleted = 0 ORDER BY attempt""",
        mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "ObjectiveReflection.sq:selectByObjective"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective_reflection", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective_reflection", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_169_977_945,
        """SELECT objective_reflection.id, objective_reflection.objective_id, objective_reflection.attempt, objective_reflection.text, objective_reflection.missed_deadline, objective_reflection.created_at, objective_reflection.updated_at, objective_reflection.is_deleted, objective_reflection.deleted_at, objective_reflection.synced_at FROM objective_reflection WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ObjectiveReflection.sq:selectByIdAnyState"
  }
}
